"use strict";import{TableRow as e}from"./src/TableRow.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-table-row",e);
//# sourceMappingURL=sp-table-row.js.map
